import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Button from 'shopper/components/Button';
import { Dropdown } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';

import placeholder from 'lib/placeholder';

import CategoriesDropdown from './CategoriesDropdown';
import FeaturedLandings from './FeaturedLandings';
import NavItem from './NavItem';
import SponsoredAds from './SponsoredAds';
import StoresDropdown from './StoresDropdown';

import LINKS from 'constants/links';

const MAIN_NAV_LISTS = [
  {
    url: LINKS.COUPONS,
    bgUrl: null,
    text: placeholder('actions.seeCoupons'),
    gaEventAction: 'topbar_coupon_tab',
  },
  {
    url: LINKS.ALIEXPRESS_STORE,
    bgUrl: LINKS.ALIEXPRESS_FIRST_PURCHASE_DEALS,
    text: placeholder('actions.seeAliexpressSponsored'),
    gaEventAction: 'aliexpress_sponsor_tab',
    icon: <Icon name="aliexpress" />,
  },
];

const TopbarBottom = ({ gaEventCategory }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownButtonRef = useRef(null);

  return (
    <nav className="relative -mt-1 flex items-center gap-2 self-start">
      <CategoriesDropdown gaEventCategory={gaEventCategory} />
      <StoresDropdown gaEventCategory={gaEventCategory} />
      {MAIN_NAV_LISTS.map(({ bgUrl, gaEventAction, icon, text, url }) => (
        <NavItem
          key={url}
          bgUrl={bgUrl}
          gaEventAction={gaEventAction}
          gaEventCategory={gaEventCategory}
          icon={icon}
          text={text}
          unreadStatus={url === LINKS.ALIEXPRESS_STORE}
          url={url}
        />
      ))}
      <div className="hidden gap-2 xl:flex">
        <SponsoredAds gaEventCategory={gaEventCategory} />
      </div>
      <div className="hidden gap-2 xl:flex">
        <FeaturedLandings gaEventCategory={gaEventCategory} />
      </div>
      <div className="relative">
        <Button
          ref={dropdownButtonRef}
          className="relative flex 2xl:hidden"
          icon={<Icon name="more-alt" />}
          size="size3"
          type="neutral-ghost"
          onClick={() => {
            setDropdownOpen((prev) => !prev);
          }}
        />
        <Dropdown
          align="left"
          className="z-50 min-w-max rounded-3 bg-neutral-high-100 p-2 shadow-[0px_0px_10px_0px_rgba(87,87,87,0.2)] dark:border dark:border-neutral-high-200 dark:bg-neutral-low-500"
          id="stores-dropdown"
          open={isDropdownOpen}
          openerRef={dropdownButtonRef}
          renderToHTML
          onClickOutside={() => {
            setDropdownOpen(false);
          }}
        >
          <div className="xl:hidden">
            <SponsoredAds gaEventCategory={gaEventCategory} />
          </div>
          <FeaturedLandings gaEventCategory={gaEventCategory} />
        </Dropdown>
      </div>
    </nav>
  );
};

TopbarBottom.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default TopbarBottom;
